// @flow
import React, { useContext } from 'react';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { SecondaryTopBar } from '@components/breadcrumbs/SecondaryTopBar';
import { getWorkloadBreadcrumbs } from '@streaming-projects/utils';
import { SPStreamingProjectContext } from '@streaming-projects/sp-page/contexts/SPStreamingProjectContext';

import { useSPTableFlowContext } from '../contexts/SPTableFlowWorkloadContextProvider';

export const SPTableFlowWorkloadBreadcrumbs = () => {
  const spOrgData = useContext(SPOrgContext);
  const spStreamingProjectData = useContext(SPStreamingProjectContext);
  const spTableFlowWorkloadData = useSPTableFlowContext();
  const workloadName = spTableFlowWorkloadData?.name;
  return (
    <SecondaryTopBar
      sectionsToShow={getWorkloadBreadcrumbs(
        spOrgData,
        spStreamingProjectData,
        workloadName,
        'Tableflow'
      )}
      showLastUpdatedMessage={false}
    />
  );
};
